import { render, staticRenderFns } from "./NicheWorshipGoods.vue?vue&type=template&id=83ffcb0e&scoped=true"
import script from "./NicheWorshipGoods.vue?vue&type=script&lang=js"
export * from "./NicheWorshipGoods.vue?vue&type=script&lang=js"
import style0 from "./NicheWorshipGoods.vue?vue&type=style&index=0&id=83ffcb0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ffcb0e",
  null
  
)

export default component.exports